import { numberWithCommas } from 'common/utils/app.utils';
import React from 'react';

export const CELLTYPE_ENUM = {
  LINK: 'Link',
  TEXT: 'Text',
  CHECKBOX: 'Checkbox'
};

export const SORTTYPE_ENUM = {
  DESCENDING: 'descending',
  ASCENDING: 'ascending',
  DEFAULT: 'default'
};

export const SHOWROWS_ENUM = {
  defaultValue: 10,
  options: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
};

export const getShowRowsOptions = (rows, totalRecords) => {
  if (Array.isArray(rows)) {
    const nearest10digitNumber = totalRecords > 10 ? Math.ceil(totalRecords / 10) * 10 : 10;
    return rows
      .map((val) => {
        return { displayName: `${val} Rows`, key: val };
      })
      .filter(({ key }) => key <= nearest10digitNumber);
  }
  // debugger;

  return [];
};

const CELL_TYPE_CLASSESS_ENUM = {
  [CELLTYPE_ENUM.LINK]: 'value_link',
  [CELLTYPE_ENUM.TEXT]: 'b2b-lib-title_text'
};

const SORT_TYPE_CLASSESS_ENUM = {
  [SORTTYPE_ENUM.DESCENDING]: 'descending',
  [SORTTYPE_ENUM.ASCENDING]: 'ascending',
  [SORTTYPE_ENUM.DEFAULT]: 'default'
};

export const getCellClass = (type) => {
  return CELL_TYPE_CLASSESS_ENUM[type] || CELL_TYPE_CLASSESS_ENUM[CELLTYPE_ENUM.TEXT];
};

export const getSortClass = (type) => {
  return SORT_TYPE_CLASSESS_ENUM[type] || SORT_TYPE_CLASSESS_ENUM[SORTTYPE_ENUM.DEFAULT];
};

export const toggleSort = (currentSort) => {
  if (currentSort) {
    return currentSort === SORTTYPE_ENUM.ASCENDING ? getSortClass(SORTTYPE_ENUM.DESCENDING) : getSortClass(SORTTYPE_ENUM.ASCENDING);
  }
  return getSortClass(SORTTYPE_ENUM.DEFAULT);
};

export const isLinkType = (cellType) => [CELLTYPE_ENUM.CHECKBOX, CELLTYPE_ENUM.LINK].includes(cellType);

export const DEFAULT_SORT_MODEL = {};

export const prepareSortModel = (sorts, activeColumn, multiSort) => {
  if (Array.isArray(sorts)) {
    return sorts.reduce((accumuator, sort, index) => {
      if (activeColumn['sortKey'] === sort.sortKey || multiSort) {
        accumuator[`sort[${0}].field`] = sort.sortKey;
        accumuator[`sort[${0}].ascending`] = sort.sortType === SORTTYPE_ENUM.ASCENDING;
      }
      return accumuator;
    }, {});
  }
  return null;
};
